export default __webpack_public_path__ + "1f7a5c76edeaf3994b8bd56129cc7ddf.svg";